import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { AuthenticationService } from '../core/authentication.service';
import { NotificationSearchFilter } from '../searchFilters/notificationSearchFilter';
import { AppSettings } from '../shared/App-Settings';

const apiUrl = AppSettings.API_BASE_URL + "api/";


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  notificationObservable: Observable<any> = new Observable<any>();
  private currentValue: BehaviorSubject<any>;

  constructor(private httpClient: HttpClient, private auth: AuthenticationService) {

    this.currentValue = new BehaviorSubject<any>(1);
    this.notificationObservable = this.currentValue.asObservable();
  }

  pushNext() {
    this.currentValue.next(1);
  }
  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getNotification(currentPage: number, pageSize: number, order: string, sortby: string, notificationSearchFilter: NotificationSearchFilter) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}NotificationCollection`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;


    if (notificationSearchFilter.userId) {
      url = url + '&UserId=' + notificationSearchFilter.userId;
    }
    if (notificationSearchFilter.notificationId) {
      url = url + '&notificationId=' + notificationSearchFilter.notificationId;
    }
    if (notificationSearchFilter.isRead) {
      url = url + '&isRead=' + notificationSearchFilter.isRead;
    }

    let notifications = this.httpClient.get<any>(url, httpOptions);
    return notifications;
  }

  markAsRead(notificationId?: number) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url;
    if (notificationId)
      url = `${apiUrl}Notifications/MarkAsRead?notificationId=${notificationId}`;
    else
      url = `${apiUrl}Notifications/MarkAsRead`;

    return this.httpClient.put<number>(url, {}, httpOptions);
  }

  markAsReadMultiple(notificationIds: string) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url;

    url = `${apiUrl}Notifications/MarkAsRead?notificationIds=${notificationIds}`;

    return this.httpClient.put<number>(url, {}, httpOptions);
  }

  getNotificationList(notificationSearchFilter: NotificationSearchFilter) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}GetNotificationList`;
    url = url + '?isRead=' + notificationSearchFilter.isRead;
    return this.httpClient.get<any>(url, httpOptions);
  }
}

